import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { colors, consumerTheme, notificationBar, statusColors } from '../../../defaultTheme';
const { darkGrey, darkRed, darkYellow, neutralGrey, paleYellow } = colors;
const { background, badgeBackground } = notificationBar.success;
const { hover } = consumerTheme.button.primary;
const severityOptions = {
    high: {
        alertTextLabel: darkRed,
        alertBackgroundColor: statusColors.error.background,
        iconColor: darkRed,
        icon: faExclamationTriangle
    },
    medium: {
        alertTextLabel: darkYellow,
        alertBackgroundColor: paleYellow,
        iconColor: darkYellow,
        icon: faExclamationCircle
    },
    rectified: {
        alertTextLabel: badgeBackground,
        alertBackgroundColor: background,
        iconColor: badgeBackground,
        icon: faCheckCircle
    },
    info: {
        alertTextLabel: hover,
        alertBackgroundColor: statusColors.info.background,
        iconColor: hover,
        icon: faInfoCircle
    },
    offline: {
        alertTextLabel: darkGrey,
        alertBackgroundColor: neutralGrey,
        iconColor: darkGrey,
        icon: faExclamationTriangle
    }
};
export default severityOptions;
//# sourceMappingURL=helpers.js.map